<template>
  <el-card>
    <div class="toolbar">
      <el-button type="primary" @click="onCreateItem()">
        <i class="fas fa-plus"></i> 新增软件
      </el-button>
      <div class="former">
        <el-input
          v-model="former['Name:like']"
          placeholder="软件名称"
          @keydown.enter.native="onSubmitQuery"
        ></el-input>&nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-search"></i>
        </el-button>
      </div>
    </div>
    <el-table :data="itemList" v-loading="loading" size="medium">
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(48, (pager.size * (pager.page)).toString().length * 12)"
      />
      <el-table-column prop="Name" label="软件名称" />
      <el-table-column prop="Class" label="分类">
        <template slot-scope="scope">
          <div v-if="scope.row.Type==1">分类1</div>
          <div v-if="scope.row.Type==2">分类2</div>
          <div v-if="scope.row.Type==3">分类3</div>
        </template>
      </el-table-column>
      <el-table-column prop="LatestVersion.Version" label="最新版本号" />
      <el-table-column prop="LatestVersion.FunctionVersion" label="包含功能版本">
        <template slot-scope="scope">
          <div v-if="scope.row.LatestVersion">
            <div v-if="scope.row.LatestVersion.FunctionVersion==1">版本1</div>
            <div v-if="scope.row.LatestVersion.FunctionVersion==2">版本2</div>
            <div v-if="scope.row.LatestVersion.FunctionVersion==3">版本3</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="180" label="操作">
        <template slot-scope="scope">
          <el-button type="primary" @click.stop="onUpdatePack(scope.row)" title="发布新版本">
            <i class="fas fa-upload"></i>
          </el-button>
          <el-button type="primary" @click.stop="onSeeItem(scope.row)" title="详情">
            <i class="fas fa-eye"></i>
          </el-button>
          <el-button type="primary" @click.stop="onEditItem(scope.row)" title="编辑">
            <i class="fas fa-pencil-alt"></i>
          </el-button>
          <el-button type="danger" @click.stop="onDeleteItem(scope.row)" title="删除">
            <i class="fas fa-trash-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      ></el-pagination>
    </div>

    <item-form v-model="item" :visible.sync="itemVisible" @form:saved="getItemList" />
    <update-pack v-model="item" :visible.sync="updateVisible" @form:saved="getItemList" />
  </el-card>
</template>

<script>
import ItemForm from './index--form.vue';
import UpdatePack from './update--pack.vue';

export default {
  components: {
    ItemForm,
    UpdatePack,
  },
  data() {
    return {
      class: [
        {
          value: 1,
          label: '类型1',
        },
        {
          value: 2,
          label: '类型2',
        },
        {
          value: 3,
          label: '类型3',
        },
      ],
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      former: {
        'Name:like': '',
      },
      item: {},
      itemVisible: false,
      updateVisible: false,
    };
  },
  mounted() { },
  created() {
    this.getItemList();
  },
  methods: {
    getItemList() {
      this.loading = true;
      this.$axios.get('software', {
        params: {
          where: this.former,
          with: ['Versions'],
          Main: 2,
          ...this.pager,
        },
      }).then((response) => {
        this.itemList = response.data.data;
        this.pager = _.pick(response.data, 'size', 'page', 'total');
      }).catch(({ response }) => {
        this.$sys.alarmResponse(response);
      }).finally(() => {
        this.loading = false;
      });
    },
    onCreateItem() {
      this.item = this.getEmptyItem();
      this.itemVisible = true;
    },
    getEmptyItem() {
      return {
      };
    },
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    onEditItem(row) {
      this.item = row;
      this.itemVisible = true;
    },
    onDeleteItem(row) {
      this.$confirm('确定要删除此软件吗？', '提示').then(
        () => this.$axios.delete(`software/${row.ID}`)
      ).then(() => {
        this.getItemList();
        this.$message.success('成功删除分组');
      }).catch(({ response }) => {
        this.$sys.alarmResponse(response);
      });
    },
    onUpdatePack(row) {
      this.item = row;
      this.updateVisible = true;
    },
    onSeeItem(row) {
      this.$router.push({ name: 'MsUpDetail', params: { ID: row.ID } });
    },
  },
};
</script>
